import { Pipe, PipeTransform } from '@angular/core';
import BigNumber from 'bignumber.js';
import { BigNumberInputService } from '@app/features/active/services/big-number-input.service';
/**
 * Pipe that formats the number values. It is mainly used in the `Input` component supported by `UI Studio` tool.
 *
 * This class should not be modified.
 */
@Pipe({
  name: 'BigNumber'
})
export class BigNumberPipe implements PipeTransform {

  constructor(private bigNumberInputService: BigNumberInputService) { }
  /**
   * Formats the provided value using native Angular Pipe
   * @param value
   * @param fractionSize
   */
  transform(value: number | string, decimalNumber?: number): string {
    const bigNumber = new BigNumber(value);
    let roundedNumber: string =  bigNumber.toFixed();;
    if (decimalNumber || decimalNumber == 0) {
      roundedNumber = bigNumber.toFixed(decimalNumber);
    }
    return this.bigNumberInputService.addSeparator(roundedNumber,decimalNumber);
  }
}
